import { ComboboxItem, Stack, Text, Tooltip } from '@mantine/core';
import { Dropzone } from '@mantine/dropzone';
import { notifications } from '@mantine/notifications';
import React from 'react';
import classes from './DropZone.module.css';
import { useFlags } from 'src/feature-flags/FlagsHook';

type Props = {
  documentType: ComboboxItem;
  onFilesSelected: (files: File[]) => void;
  onOneDriveClick: (e: React.MouseEvent<HTMLElement>) => void;
};

export function DropZone({ onFilesSelected, onOneDriveClick }: Props) {
  const { flagEnabledSharepoint } = useFlags();

  const handleFilesSelected = (files: File[]) => {
    onFilesSelected(files);
  };

  return (
    <>
      <Dropzone
        onDrop={handleFilesSelected}
        onReject={fileRejections => {
          fileRejections.forEach(fileRejection => {
            notifications.show({
              title: `Failed to upload ${fileRejection.file.name}`,
              message: fileRejection.errors.map(e => e.message).join('\n'),
              color: 'red',
            });
          });
        }}
        maxSize={2147483648} // 2GB
        style={{
          border: '1px dashed #b4bbc7',
          borderRadius: '16px',
          padding: '32px',
        }}
        maxFiles={5}
        accept={{
          'image/png': [],
          'image/jpg': [],
          'image/jpeg': [],
          'application/pdf': [],
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [], // DOCX
          'text/plain': [],
          'text/csv': ['.csv'],
          'application/vnd.ms-excel': ['.xls'],
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
          'application/vnd.ms-excel.sheet.macroEnabled.12': ['.xlsm'],
          'audio/mpeg': [], // MP3
          'video/mp4': [],
          'audio/wav': [],
          'audio/aac': [],
          'audio/flac': [],
          'audio/ogg': [],
          'audio/mp4': ['.m4a'],
          'audio/x-m4a': ['.m4a'],
          'video/quicktime': ['.mov'],
        }}
      >
        <Stack justify={'center'} align={'center'} style={{ width: '100%' }}>
          {flagEnabledSharepoint ? (
            <Text size="lg" fw={600} ta={'center'}>
              Add your clients data here, either from{' '}
              <Text
                span
                size="lg"
                className={classes.uploadLabel}
                onClick={e => onOneDriveClick(e)}
              >
                SharePoint
              </Text>{' '}
              or{' '}
              <Text span size="lg" className={classes.uploadLabel}>
                upload from your computer
              </Text>
            </Text>
          ) : (
            <Text size="lg" fw={600} ta={'center'}>
              Add your clients data here,{' '}
              <Text span size="lg" className={classes.uploadLabel}>
                upload from your computer
              </Text>
            </Text>
          )}
          <Tooltip label="DOCX, PDF, CSV, Excel, MP3, MP4, M4A, WAV, MOV" position="top" withArrow>
            <Text size="xs" className={classes.fileTypesLabel} style={{ alignSelf: 'flex-end' }}>
              Supported file types
            </Text>
          </Tooltip>
        </Stack>
      </Dropzone>
    </>
  );
}
